export function resolveLocalizedText(textEn: string, textPl: string, activeLanguage: string): string {
  if (activeLanguage === 'pl' && textPl.length > 0) {
    return textPl;
  }
  return textEn;
}
